import { render, staticRenderFns } from "./MerchantSelector.vue?vue&type=template&id=20311c04&scoped=true"
import script from "./MerchantSelector.vue?vue&type=script&lang=js"
export * from "./MerchantSelector.vue?vue&type=script&lang=js"
import style0 from "./MerchantSelector.vue?vue&type=style&index=0&id=20311c04&prod&scoped=true&lang=css"
import style1 from "./MerchantSelector.vue?vue&type=style&index=1&id=20311c04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20311c04",
  null
  
)

export default component.exports